import * as React from 'react';
import configData from "../config.json";
import { GetToken, GetSession } from '../components/Session';
import { Induction } from './Induction';
//import './Mobile.scss';

const MobileInduction = () => {
    const [message, setMessage] = React.useState("");
    const finished = () => {
        setMessage("Inductions are up to date");
    }

    return (
        <div id="MobileInduction">
            {message === "" && <Induction finished={finished} />}
            {message !== "" && <div className="inductionMessage">{message}</div>}
        </div>
    );
}

export default MobileInduction;